import { OrderState, ReturnPaymentState, ReturnShipmentState } from '~/types/GraphQL';
import type { Maybe, PaymentState, RawCustomField, ShipmentState } from '~/types/GraphQL';

const calculateAge = (birthday: Date) => {
  const currentDate = new Date();
  const diff = currentDate.valueOf() - birthday.valueOf();
  // This is the difference in milliseconds
  const currentAge = Math.floor(diff / 31557600000);
  // Divide by 1000*60*60*24*365.25
  return currentAge;
};

const findAttr = (attributes: RawCustomField[], name: string) => attributes.find(attr => attr.name === name)?.value;

const getLocalizedDate = (date: Date, locale: string) => {
  const createdAt = new Date(date);

  return createdAt.toLocaleDateString(locale, {
    year: 'numeric', month: '2-digit', day: 'numeric',
  });
};

function getReturnStatus(shipmentState: ReturnShipmentState, paymentState: ReturnPaymentState) {
  if (
    shipmentState === ReturnShipmentState.Returned
    || (shipmentState === ReturnShipmentState.BackInStock && paymentState === ReturnPaymentState.Initial)
  ) {
    return 'In process';
  }
  if (shipmentState === ReturnShipmentState.BackInStock && paymentState === ReturnPaymentState.Refunded) {
    return 'finalized';
  }
  if (shipmentState === ReturnShipmentState.BackInStock && paymentState === ReturnPaymentState.NotRefunded) {
    return 'Clarification case';
  }

  return '';
}

function getOrderStatus(paymentMethod: Maybe<string | undefined>, orderStatus: OrderState | undefined, shipmentStatus: Maybe<ReturnShipmentState | ShipmentState | undefined>, paymentStatus: Maybe<PaymentState | undefined>) {
  switch (paymentMethod) {
    case 'vorkasse': {
      if (orderStatus === OrderState.Open) {
        return 'Waiting for payment';
      }
      if (orderStatus === OrderState.Confirmed && paymentStatus === 'Pending') {
        return 'Waiting for payment';
      }
      if (orderStatus === OrderState.Confirmed && paymentStatus === 'Paid') {
        return 'In process';
      }
      if (orderStatus === OrderState.Complete) {
        return 'shipped';
      }
      if (orderStatus === OrderState.Cancelled) {
        return 'cancelled';
      }
      return '';
    }
    case 'kik_filiale': {
      if (orderStatus === OrderState.Open) {
        return 'In process';
      }
      if (orderStatus === OrderState.Confirmed && shipmentStatus === 'Pending' && paymentStatus === 'Pending') {
        return 'On the way to the store';
      }
      if (orderStatus === OrderState.Confirmed && shipmentStatus === 'Shipped' && paymentStatus === 'Pending') {
        return 'Ready for pickup in the store';
      }
      if (orderStatus === OrderState.Confirmed && paymentStatus === 'Pending') {
        return 'In process';
      }
      if (orderStatus === OrderState.Complete) {
        return 'Picked up at the store';
      }
      if (orderStatus === OrderState.Cancelled) {
        return 'cancelled';
      }
      return '';
    }
    default: {
      if (orderStatus === OrderState.Open) {
        return 'In process';
      }
      if (orderStatus === OrderState.Confirmed) {
        return 'In process';
      }
      if (orderStatus === OrderState.Complete) {
        return 'shipped';
      }
      if (orderStatus === OrderState.Cancelled) {
        return 'cancelled';
      }
      return '';
    }
  }
}

export {
  getOrderStatus,
  getReturnStatus,
  getLocalizedDate,
  findAttr,
  calculateAge,
};
